"use client";
import React, { useRef, useState } from "react";
import { IoPlaySharp, IoPauseSharp } from "react-icons/io5";
import LocationDate from "./LocationDate";
import ui3 from "@/assest/ui3.png";
import ui10 from "@/assest/ui10.png";
import ui11 from "@/assest/ui11.png";
import Image from "next/image";
// import { IHeroRecord } from "@/app/package/interface/IHeroSection";

interface HomeHeroProps {
  // heroData?: IHeroRecord[];
  city?: { name: string; slug: string }[];
}

const HomeHero: React.FC<HomeHeroProps> = ({ city }) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [paused, setPaused] = useState(true);
  const togglePlay = () => {
    if (!videoRef.current) return;

    if (paused) {
      videoRef.current.play();
    } else {
      videoRef.current.pause();
    }
    setPaused(!paused);
  };

  return (
    <div className="pb-5 padding-x relative">
      <Image
        src={ui11}
        alt="ui accent"
        width={500}
        height={500}
        className="hidden md:block absolute -top-[50%] left-[8%] z-10 object-cover"
      />

      <video
        ref={videoRef}
        src="/goodtravel.mp4"
        className="w-full h-[75vh] object-cover rounded-[50px]"
        onPlay={() => setPaused(false)}
        onPause={() => setPaused(true)}
        playsInline
        muted
        autoPlay
        loop
        preload="metadata"
      />
      {/* circular ring around the play/pause button */}
      <div className="absolute top-[10%] left-1/2 transform -translate-x-1/2 pointer-events-none z-20 items-center text-center">
        <h2 className="text-white text-2xl md:text-4xl lg:text-7xl mb-9">
          Discover Your
        </h2>
        <p className="text-white text-3xl font-light">- Dream Destinations</p>
      </div>
      <div className="absolute left-1/2 top-[45%] transform -translate-x-1/2 -translate-y-1/2 flex items-center justify-center pointer-events-none">
        <span className="absolute w-[130px] h-[130px] rounded-full border-2 border-white animate-pulse" />
        <button
          onClick={togglePlay}
          className="relative z-10 pointer-events-auto bg-white/30 hover:bg-white/15 items-center justify-center p-4 rounded-full overflow-hidden m-1.5"
        >
          {paused ? (
            <IoPlaySharp size={70} color="white" />
          ) : (
            <IoPauseSharp size={70} color="white" />
          )}
        </button>
      </div>

      <div className="hidden relative md:flex">
        <div className="relative px-5 py-2 bg-white/65 backdrop-blur-xs rounded-2xl shadow-sm md:-top-10 md:left-50 typography-sub-h3-light md:w-2/3 justify-center inline-flex">
          <div className="flex flex-row md:space-x-8 md:px-9 md:py-2"></div>
          <LocationDate city={city} />
        </div>
        <Image
          src={ui3}
          alt="ui accent"
          width={100}
          height={100}
          className="absolute top-10 right-20 z-0 object-cover"
        />
        <Image
          src={ui10}
          alt="ui accent"
          width={150}
          height={150}
          className="absolute top-28 left-20 z-0 object-cover"
        />
      </div>
    </div>
  );
};

export default HomeHero;
